<form [formGroup]="filterForms" (ngSubmit)="checkAndCallMethods()">
    <div>
        <!-- Filter dropdown -->
        @if (localTableFilters.length > 0) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>Filter</mat-label>
            <mat-select formControlName="tableFilter" (selectionChange)="changeValue($event.value)" [compareWith]="compareFilters">
                @for (filter of localTableFilters; track filter.displayName) {
                <mat-option [value]="filter">
                    {{ filter.displayName }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }

        <!-- Dynamic value input -->
        @if (filterForms.value.tableFilter) {
        <!-- Case: Select from array (Standard) -->
        @if (isArrayType && !isWorkOrderType) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>{{ currentDisplayName }}</mat-label>
            <mat-select formControlName="value" (selectionChange)="onValueSelected($event.value)">
                @for (val of filterForms.value.tableFilter.values; track $index) {
                <mat-option [value]="val">
                    {{ val }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        <!-- Case: Work Order Type -->
        @if (isWorkOrderType) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>{{ currentDisplayName }}</mat-label>
            <mat-select formControlName="value">
                @for (workOrder of workOrderOptions; track $index) {
                <mat-option [value]="workOrder">
                    {{ workOrder }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        <!-- Case: Text input -->
        @if (!isArrayType && !isWorkOrderType && !isSingleDateValue) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>{{ currentDisplayName }}</mat-label>
            <input matInput [placeholder]="currentDisplayName" formControlName="value">
        </mat-form-field>
        }
        }


        @if (dateFilterSelected) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>{{ filterForms.value.value || currentDisplayName || 'Choose date range' }}</mat-label>
            <input matInput type="text" bsDaterangepicker [bsConfig]="bsConfig"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [(ngModel)]="bsRangeValue" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        }

        <!-- Action buttons -->
        <div class="buttons">
            <button mat-flat-button color="primary" class="button" type="submit" [disabled]="isFilterSet()"
                (click)="isAddFilterClicked()">Add</button>
            <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isWONumberFilterApplied()"
                (click)="isSearchClicked()">Search</button>
            <button mat-flat-button color="primary" class="button" [disabled]="!isWONumberFilterApplied()"
                (click)="isExcelClicked()">Export</button>
            <button mat-stroked-button class="button" [disabled]="!isAnyFilterSet()" (click)="reset()">Reset</button>
        </div>

        <!-- Chips display -->
        @if (filterAdded) {
        <div class="chips">
            <mat-chip-set class="example-chip-list" aria-label="Filter selection">
                @for (filters of filterArray; track filters.value) {
                <mat-chip (removed)="remove(filters.value)">
                    {{filters.dispalyName}} - {{filters.value}}
                    @if (removable) {
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                    }
                </mat-chip>
                }
            </mat-chip-set>
        </div>
        }
    </div>
</form>



<!-- Loading spinner -->
@if (isLoadingResults) {
<div class="loading-shade">
    <mat-spinner></mat-spinner>
</div>
}